import { useRoutes } from '@folklore/routes';
// import PropTypes from 'prop-types';
import { Route, Switch, useLocation } from 'wouter';

import usePage from '../hooks/usePage';

import AccountPage from './pages/Account';
import AccountPrizePage from './pages/AccountPrize';
import AccountPrizesPage from './pages/AccountPrizes';
import BonusPage from './pages/BonusPage';
import DisplayPage from './pages/Display';
import DisplaysPage from './pages/Displays';
import ErrorPage from './pages/Error';
import GamePage from './pages/Game';
import HomePage from './pages/Home';
import LeaderboardPage from './pages/Leaderboard';
import Page from './pages/Page';
import PlayPage from './pages/Play';
import ProfilePage from './pages/Profile';
import RegisterPage from './pages/Register';

import '../../styles/styles.css';

function Routes() {
    const routes = useRoutes() || {};
    const [location] = useLocation();
    const { isLoading, notFound = false } = usePage(location, {
        keepPreviousData: true,
    });

    if (isLoading) {
        return null;
    }

    if (notFound) {
        return <ErrorPage statusCode={404} />;
    }

    return (
        <Switch>
            <Route path={routes.home || '/'}>
                <HomePage />
            </Route>
            <Route path={routes.displays}>
                <DisplaysPage />
            </Route>
            <Route path={routes.display}>
                <DisplayPage />
            </Route>
            <Route path={routes['display.step']}>
                <DisplayPage />
            </Route>
            <Route path={routes.bonus}>
                <BonusPage />
            </Route>
            <Route path={routes.game}>
                <GamePage />
            </Route>
            <Route path={routes['game.question']}>
                <GamePage />
            </Route>
            <Route path={routes.play}>
                <PlayPage />
            </Route>
            <Route path={routes[`play.group`]}>
                <PlayPage />
            </Route>
            <Route path={routes.participation}>
                <GamePage />
            </Route>
            <Route path={routes['participation.question']}>
                <GamePage />
            </Route>
            <Route path={routes.leaderboard}>
                <LeaderboardPage />
            </Route>
            <Route path={routes.register}>
                <RegisterPage />
            </Route>
            <Route path={routes.profile}>
                <ProfilePage />
            </Route>
            <Route path={routes.account}>
                <AccountPage />
            </Route>
            <Route path={routes.prize}>
                <AccountPrizePage />
            </Route>
            <Route path={routes.prizes}>
                <AccountPrizesPage />
            </Route>
            <Route path={routes.page}>
                <Page />
            </Route>
            <Route>
                <ErrorPage statusCode={404} />
            </Route>
        </Switch>
    );
}

export default Routes;
